import { faker } from '@faker-js/faker';
import { sample } from 'lodash';

// ----------------------------------------------------------------------

const users = [...Array(24)].map((_, index) => ({
  id: faker.datatype.uuid(),
  avatarUrl: `/assets/images/avatars/avatar_${index + 1}.jpg`,
  name: faker.name.fullName(),
  location: faker.address.state(),
  posted: faker.date.month(),
  status: sample(['Initiated', 'In-Progress', 'Solved', 'Rejected', ]),
  role: sample([
    'Citizen',
  ]),
}));

export default users;
